import { getEnv } from './env'

const CONFIG_BASE =
  'https://myolivia.blob.core.windows.net/myolivia/config'

const PROD_CONFIG_FILE = 'production.json'

export const PROD_CONFIG_URI = `${CONFIG_BASE}/${PROD_CONFIG_FILE}`

const REQUEST_TIMEOUT = 10000

// The config file is picked from the API host, so an environment can never read
// another one's flags when nobody sets CONFIG_URL. The mapping mirrors the
// graphql_url each of these files declares.
const CONFIG_FILE_BY_API_HOST: Record<string, string> = {
  'dgraph.app.oliviacentre.com': PROD_CONFIG_FILE,
  'garden.preprod.dev.oliviacentre.com': 'preprod.json',
  'garden.alpha.dev.oliviacentre.com': 'alpha.json',
  'gqlproxy.alpha.dev.oliviacentre.com': 'alpha-proxy.json',
  'dgraph.beta.oliviacentre.pl': 'beta.json',
  'garden.stage-1.dev.oliviacentre.com': 'stage-1.json',
}

export interface IAppConfig {
  maintenance_mycompany?: boolean
  maintenance_mycompany_msg?: string
}

const readEnv = (name: string): string | undefined => {
  try {
    return getEnv(name)
  } catch {
    return undefined
  }
}

const getApiHost = () => {
  const apiUrl = readEnv('API_URL')
  if (!apiUrl) {
    return undefined
  }
  try {
    return new URL(apiUrl).host
  } catch {
    return undefined
  }
}

export const getConfigUri = () => {
  // an explicit CONFIG_URL still wins, so a single environment can be pointed
  // anywhere without a release
  const explicitUri = readEnv('CONFIG_URL')
  if (explicitUri) {
    return explicitUri
  }

  const apiHost = getApiHost()
  const configFile =
    (apiHost && CONFIG_FILE_BY_API_HOST[apiHost]) || PROD_CONFIG_FILE

  return `${CONFIG_BASE}/${configFile}`
}

export const fetchAppConfig = async (): Promise<IAppConfig> => {
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), REQUEST_TIMEOUT)

  try {
    const response = await fetch(`${getConfigUri()}?${Date.now()}`, {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
      signal: controller.signal,
    })

    if (!response.ok) {
      throw new Error(`Config request failed with status ${response.status}`)
    }

    return await response.json()
  } finally {
    clearTimeout(timeout)
  }
}
